/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnergyEfficiencySummaryCodeUIDTOV0 } from './energyEfficiencySummaryCodeUIDTOV0';


export interface PropertySummaryTypeUIDTOV0 { 
    /**
     * Overall description of the property feature.
     */
    description?: string;
    energyEfficiencyRating?: EnergyEfficiencySummaryCodeUIDTOV0;
    environmentalEfficiencyRating?: EnergyEfficiencySummaryCodeUIDTOV0;
}
export namespace PropertySummaryTypeUIDTOV0 {
}


